<div class="row align-items-end mx-1">
    <!-- Search ID -->
    <div class="col-lg-6 col-md-12">
        <mat-form-field appearance="outline" class="w-100 mb-0">
            <mat-label>Search ID</mat-label>
            <input matInput type="text" placeholder="Search ID..." (keyup)="updateFilter($event)" />
        </mat-form-field>
    </div>

    <!-- Date Filter -->
    <div class="col-lg-6 col-md-12">
        <mat-form-field appearance="outline" class="w-100 mb-0">
            <mat-label>Search By Date</mat-label>

            <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
                <input matStartDate readonly formControlName="start" placeholder="Start date" />
                <input matEndDate readonly formControlName="end" placeholder="End date" />


            </mat-date-range-input>

            <div matSuffix style="display: flex; align-items: center; gap: 1px;">
                <button mat-icon-button *ngIf="range.value?.start || range.value?.end" (click)="clearDateRange()"
                    type="button">
                    <i class="bi bi-x-circle" style="font-size: 15px; color: #707070;"></i>
                </button>
                <mat-datepicker-toggle [for]="picker"></mat-datepicker-toggle>
            </div>



            <mat-date-range-picker #picker (closed)="showDate()"></mat-date-range-picker>
        </mat-form-field>
    </div>


</div>
<br>
<ngx-datatable class="material" [rows]="data" [columnMode]="'force'" [headerHeight]="50" [footerHeight]="50"
    [rowHeight]="'auto'" [scrollbarV]="false" [limit]="10" [sorts]="[{dir: 'desc'}]"
    style="position: relative !important;">
    <ngx-datatable-column [flexGrow]="1" name="Wallet Id" prop="oId">
        <ng-template let-row="row" ngx-datatable-cell-template>
            #{{row.oId}}
        </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column [flexGrow]="1" name="Customer">
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{row.customerId?.name}} - #{{row.customerId?.customerAutoId}}
        </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column [flexGrow]="1" name="Amount" prop="amount">
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{row.currencySymbol}} {{row.amount | number: '.2-2'}} ({{row.currencyCode}})
        </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column [flexGrow]="1" name="GST" prop="gst_amount">
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{row.currencySymbol}} {{row.gst_amount | number: '.2-2'}} ({{row.currencyCode}})
        </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column [flexGrow]="1" name="Total Amount" prop="final_amount">
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{row.currencySymbol}} {{row.final_amount | number: '.2-2'}} ({{row.currencyCode}})
        </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column [flexGrow]="1" name="Txn. ID" prop="txnId">
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{row.txnId}}
        </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column [flexGrow]="1" name="Invoice" prop="invoiceUrl">
        <ng-template let-row="row" ngx-datatable-cell-template>
            <a *ngIf="row.invoiceUrl != ''" [href]=getSanitizeUrl(row.invoiceUrl) target="_blank">Invoice</a>
            <span *ngIf="row.invoiceUrl == ''" class="text-dangers">Invoice</span>
        </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column [flexGrow]="2" name="Date" prop="created_at">
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{row.created_at | date:'medium'}}
        </ng-template>
    </ngx-datatable-column>
</ngx-datatable>